<template lang="pug">
  div.account-holidays
    div.col-block.accounts-title
      div.title
        p Информация об отсутствии физического лица
        e-button-add(
        v-if="model && model.id"
        @click="addRow()"
        )

    div(:class="{'is-invalid': getError}").accounts
      e-table-editable(
      v-if="model && model.id"
      ref="editTable"
      :attributes="attr"
      :dataUrl="dataEndpoint"
      :postUrl="() => null"
      :patchUrl="() => null"
      :deleteUrl="() => null"
      :tableInOnlineMode="false"
      :tableHeight="'180'"
      :tableHeightRight="'180'"
      :fewRowsCount="2"
      )
      p(v-else) Добавление данной информации возможно только во время редактирования записи

    div.invalid-relative-container
      transition(v-if="getError" name="fade")
        span( v-show="error").invalid.error {{error}}
</template>

<script>
  import {editableValidatorMixin} from "../../../components/table-editable/editable-validator-mixin";
  import {individuals} from "../../../api/api-endpoints";

  export default {
    name: "account-holidays",
    mixins: [editableValidatorMixin],
    props: {
      tabView: null,
      dataUrl: {
        type: Function
      },
      model: {
        type: Object
      }
    },
    computed: {
      dataEndpoint () {
        return this.dataUrl()
      },
      allAccounts () {
        return this.$store.getters.readUrlEndpoint(
          this.getAllAccounts()
        )
      },
      allAccountsOptions () {
        if (!this.allAccounts) {
          return []
        }
        return this.allAccounts.data.map(v => {
          v.name = v.id
          return v
        })
      },
      attr () {
        return {
          id: {
            label: "Номер",
            placeholder: ' ',
            width: 80,
            disabled: true
          },
          number: {
            label: "Номер лицевого счета",
            width: 120,
            required: true,
            placeholder: 'Выберите счет',
            change: this.onBillingAccountIdChange,
            select: {
              options: this.allAccountsOptions
            }
          },
          absence_date_start: {
            label: "Дата начала отсутствия",
            width: 120,
            required: true,
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            calendar: {}
          },
          absence_date_end: {
            label: "Дата окончания отсутствия",
            width: 120,
            required: true,
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            calendar: {}
          },
          address: {
            label: "Адрес",
            width: 120,
            placeholder: ' ',
            disabled: true,
            validationRulePattern: '(\\.*)'
          }
        }
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      getTableRef () {
        return this.$refs.editTable
      },
      onBillingAccountIdChange (model) {
        model.address = ''
        if (model.number) {
          let selectedAccount = this.allAccountsOptions.reduce((prev, curr) =>{
            if (curr.id == model.number) {
              return curr
            }
            return prev
          })
          console.log('selectedAccount', selectedAccount)
          if (selectedAccount && selectedAccount.address) {
            model.address = selectedAccount.address
          }
        }
      },
      addRow () {
        const Model = () => ({
          number: '',
          absence_date_start: '',
          absence_date_end: '',
          address: ''
        })
        this.$refs.editTable.createRow(new Model())
      },
      fetchData () {
        if (this.model && this.model.id) {
          this.$store.dispatch('updateUrlEndpoint', {
            endpoint: this.getAllAccounts(),
            params: {
              disableGlobalError: true
            }
          })
        }
      },
      getAllAccounts() {
        return individuals.individualAccounts(this.model.id, {
          query: {
            'per-page': -1
          }
        })
      }
    }
  }
</script>
